import React, { useState, useEffect  } from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal, ModalBody, Button } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

import backlogo from '../../Assets/App_icon/back.png';
import excellogo from '../../Assets/App_icon/excel.png';


const ProductMaster = () => {
  
  const store = localStorage.getItem('store');
  const host_url = localStorage.getItem('host_url');
  const userRole = localStorage.getItem('userRole');

  const navigate = useNavigate();
  const [modalVisible, setModalVisible] = useState(false); 

  const [catlist, setCatlist] = useState([]);
  const [prdlist, setPrdlist] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState('');
  
  
  const handleBack = () => {
    navigate('../dashboard');
  };

    // Escape key press handling
    useEffect(() => {
      const handleKeyPress = (event) => {
        if (event.key === "Escape") {
          handleBack();
        }
      };

      document.addEventListener("keydown", handleKeyPress);
      return () => {
        document.removeEventListener("keydown", handleKeyPress);
      };
    }, []); 

    useEffect(() => { 
      const fetchCatagoryList = async () => { 
          const formData = new FormData();
          formData.append("type", "list");
          formData.append("store", store);
          formData.append("catlist", '');

          try {
            const response = await fetch(`${host_url}/category_mlist`, {
              method: 'POST',
              body: formData,
            });
            
            const data = await response.json();
            setCatlist(data);
          } catch (error) {
            console.error('Error fetching categories:', error);
          }
      }; 
     fetchCatagoryList(); 
    }, [host_url]); // Categoty Fetch 

    useEffect(() => { 
      const fetchCatagoryList = async () => { 
          try {
            const response = await fetch(`${host_url}/stock`, {
              method: 'POST', 
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                type: 'list',
                store: store,
                purdetail: 'null',
              }),
            });
            
            const data = await response.json();
            setPrdlist(data);
          } catch (error) {
            console.error('Error fetching categories:', error);
          }
      }; 
     fetchCatagoryList(); 
    }, [host_url]); // Product Fetch

    const [prdNameFilter, setPrdNameFilter] = useState('');
    const [prdEnameFilter, setPrdEnameFilter] = useState('');
    const [catEnameFilter, setCatEnameFilter] = useState('');
    const [stockFilter, setStockFilter] = useState('');
    const [stockAmtFilter, setStockAmtFilter] = useState('');

    const filteredPrdlist = prdlist.filter(prd =>
      prd.prd_name.toLowerCase().includes(prdNameFilter.toLowerCase()) &&
      prd.prd_Ename.toLowerCase().includes(prdEnameFilter.toLowerCase()) && 
      String(prd.pcat_id).toLowerCase().includes(catEnameFilter.toLowerCase()) && 
      (stockFilter === "" ||  (stockFilter === "Minus" && prd.prd_stock < 0) || (stockFilter === "Plus" && prd.prd_stock > 0)) &&
      (stockAmtFilter === "" ||  (stockAmtFilter === "Minus" && prd.prd_stock_amt < 0) || (stockAmtFilter === "Plus" && prd.prd_stock_amt > 0))
    );

    const totalCount = filteredPrdlist.length;
    const totalprd_stock_amt = filteredPrdlist.reduce((sum, row) => sum + Number(row.prd_stock_amt), 0);

    const exportToExcel = async () => {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Stock Report');

      // Define headers
        worksheet.columns = [
          { header: 'Category', key: 'Category', width: 20 },
          { header: 'G_Name', key: 'G_Name', width: 30 },
          { header: 'After_Order', key: 'After_Order', width: 15 },
          { header: 'Stock', key: 'Stock', width: 15 },
        ];

      // Add rows
        filteredPrdlist.forEach(item => {
          worksheet.addRow({
            Category: item.pcat_Ename,
            G_Name: item.prd_name,
            After_Order: item.ord_qty,
            Stock: item.prd_stock,
          });
        });


      // Apply borders to all cells in the worksheet
        worksheet.eachRow((row, rowNumber) => {
          row.height = 35;
          row.alignment = {vertical: 'middle'};
          row.eachCell(cell => {
            cell.border = {
              top:    { style: 'dotted' },
              left:   { style: 'dotted' },
              bottom: { style: 'dotted' },
              right:  { style: 'dotted' },
            };
          });
        });

      // ✅ Right-align "After_Order" and "Stock" columns
        worksheet.eachRow((row, rowNumber) => {
          if (rowNumber === 1) return; // Skip header row

          // After_Order = column 3, Stock = column 4 (1-based indexing)
          row.getCell(3).alignment = { vertical: 'middle', horizontal: 'right' };
          row.getCell(4).alignment = { vertical: 'middle', horizontal: 'right' };
        });

      // Apply header styles
        worksheet.getRow(1).eachCell(cell => {
          cell.font = { bold: true };
          cell.alignment = { vertical: 'middle', horizontal: 'center' };
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFEFEFEF' }
          };
        });

      // Write to file
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs(blob, 'StockReport.xlsx');
    };

    const handleStockUpdate = async () => {
      setModalVisible(false); 
      const prdupdateDetail = {
            prd_id: selectedProduct.prd_id,
            prd_stock: selectedProduct.prd_stock,
            prd_stock_amt: selectedProduct.prd_stock_amt,
        };

      try {
        console.log(prdupdateDetail);
        
        const response = await fetch(`${host_url}/stock`, {
          method: 'POST', 
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            type: 'Update', 
            store: store, 
            prddetail: prdupdateDetail, 
          }),
        });
        const data = await response.json();
        setPrdlist(data);
        
      } catch (error) {
        console.error('Error fetching cities:', error);
      }
    };

    const handlePrdDetail = async (row) => {
      setModalVisible(true);
      setSelectedProduct(row);
      console.log(row);
    };

  return (
    <div className="container">
          <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
              <div onClick={handleBack}>
                <img src={backlogo} alt="Back" className='system-icon'/>
              </div>
              <b style={{ margin: '10px', fontSize: '20px' }}>Stock Report</b>
              <div >
                <div onClick={exportToExcel}>
                  <img src={excellogo} alt="Back" className='system-icon'/>
                </div>
              </div>
          </div> 
        
          <table className="table-bordered table-sm custom-hover">
            <thead>
              <tr >
                <th colSpan='2'>Category</th>
                <th colSpan='2'>E_Name</th>
                <th colSpan='2'>G_Name</th>
                <th>Stock</th>
                <th>Amount</th>
              </tr>
              <tr>
                <th colSpan='2'>
                  <select
                    className="search-input"
                    value={catEnameFilter}
                    onChange={(e) => setCatEnameFilter(e.target.value)}
                  >
                    <option value="">All Category</option>
                    {catlist.map((catlist) => (
                      catlist.pcat_count > 0 && (
                        <option key={catlist.pcat_Id} value={catlist.pcat_id}>
                          {catlist.pcat_Ename}
                        </option>
                      )
                    ))}
                  </select>
                </th>
                <th colSpan='2'>
                  <input
                    type="text"
                    className="search-input"
                    value={prdEnameFilter}
                    onChange={(e) => setPrdEnameFilter(e.target.value)}
                  />
                </th>
                <th colSpan='2'>
                  <input
                    type="text"
                    className="search-input"
                    value={prdNameFilter}
                    onChange={(e) => setPrdNameFilter(e.target.value)}
                  />
                </th>   
                <th>
                  <select
                    className="search-input"
                    value={stockFilter}
                    onChange={(e) => setStockFilter(e.target.value)}
                  >
                    <option value="">All Status</option>
                    <option value="Minus">Minus</option>
                    <option value="Plus">Plus</option>
                  </select>  
                </th>
                <th>
                  <select
                    className="search-input"
                    value={stockAmtFilter}
                    onChange={(e) => setStockAmtFilter(e.target.value)}
                  >
                    <option value="">All Status</option>
                    <option value="Minus">Minus</option>
                    <option value="Plus">Plus</option>
                  </select> 
                </th>
              </tr>
            </thead>
            <tbody className="scrollable-body">
              {filteredPrdlist.map((row, index) => {
                  return (
                    <tr key={index} style={{ lineHeight: '10px', fontSize:'14px' }} >
                      <td className="cell-left" colSpan="2"><span style={{ paddingLeft: '10px' }}>{row.pcat_Ename}</span></td>
                      <td className="cell-left" colSpan="2">{row.prd_Ename}</td>
                      <td className="cell-left" colSpan="2">{row.prd_name}</td>
                      <td className="cell-right" style={{ color: row.prd_stock < 0 ? 'red' : 'inherit', cursor: userRole === 'Admin' ? 'pointer' : 'default' }} onClick={userRole === 'Admin' ? () => handlePrdDetail(row) : undefined} >{row.prd_stock == 0 ? '' : row.prd_stock } </td>
                      <td className="cell-right" style={{ color: row.prd_stock_amt < 0 ? 'red' : 'inherit' }} onClick={userRole === 'Admin' ? () => handlePrdDetail(row) : undefined} >{row.prd_stock == 0 ? '' : row.prd_stock_amt } </td>
                    </tr>
                  );
              })}
            </tbody>
            <tfoot>
              <tr >
                <th className="cell-left" colSpan='2'><span style={{ paddingLeft: '10px' }}>{totalCount}</span></th>
                <th className="cell-left" colSpan='2'><span style={{ paddingLeft: '10px' }}></span></th>
                <th className="cell-left" colSpan='2'><span style={{ paddingLeft: '10px' }}></span></th>
                <th className="cell-right"><span style={{ paddingRight: '15px' }}></span></th>
                <th className="cell-right"><span style={{ paddingRight: '5px' }}>{totalprd_stock_amt}</span></th>
              </tr>
            </tfoot>
          </table>




          {/* Modal for Stock Detail */}
            <Modal isOpen={modalVisible} toggle={() => setModalVisible(!modalVisible)} className="detailmodal" backdrop="static" keyboard={false}>
              <ModalBody style={{ backgroundColor: '#e8fadb'}}> 
                  <div >
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%' }}>
                      <tbody>
                        <tr>
                          <td>Name</td>
                          <td className="cell-left" style={{ padding: '5px' }} >{selectedProduct.prd_name}</td>  
                        </tr>
                        <tr>
                          <td>Stock Qty</td>
                          <td style={{ padding: '2px' }} >
                            <input
                              type="text"
                              value={selectedProduct.prd_stock}
                              onChange={(e) => setSelectedProduct({ ...selectedProduct, prd_stock: e.target.value })}
                            />
                          </td>  
                        </tr>
                        <tr>
                          <td>Stock Amt</td>
                          <td style={{ padding: '2px' }} >
                            <input
                              type="text"
                              value={selectedProduct.prd_stock_amt}
                              onChange={(e) => setSelectedProduct({ ...selectedProduct, prd_stock_amt: e.target.value })}
                            />
                          </td>    
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <Button color="success" style={{ flex: 1, marginRight: '10px' }} onClick={handleStockUpdate} >
                      Stock Update 
                    </Button>
                    <Button color="primary" style={{ flex: 1 }} onClick={() => setModalVisible(false)}>
                      Close
                    </Button>
                  </div>
                
              </ModalBody>
            </Modal>        
        
    </div>
  );
};

export default ProductMaster;
